<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <input class="search" type="text" [(ngModel)]="search"
                placeholder="Search by title, location or industry" autocomplete="off" />
            <button class="add-btn" type="button" (click)="openAdd()">Add project</button>
        </div>

        <p class="state-text intro">
            Listed in carousel order — the same order the home page shows them in.
            @if (canReorder) {
                Drag a row by its handle to move it; the rest renumber automatically.
            } @else if (search.trim()) {
                <!-- Renumbering runs over the whole list, so a filtered subset
                     cannot be dragged without scrambling the hidden rows. -->
                <strong>Clear the search to reorder by dragging.</strong>
            }
        </p>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (projects.length === 0) {
            <p class="state-text">No projects yet.</p>
        } @else if (filtered.length === 0) {
            <p class="state-text">No projects match your search.</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <!-- Every column carries a header: a blank one made the row
                                 hard to read across, because the eye paired each label with
                                 whichever column it happened to sit nearest. The drag handle
                                 has no header of its own — it moved into the Display order
                                 cell, which is the thing it changes. -->
                            <th class="order-col">Display order</th>
                            <th class="thumb-col">Image</th>
                            <th>Title</th>
                            <th>Location</th>
                            <th>Industry</th>
                            <th class="lang-col">Translations</th>
                            <th class="actions-col">Actions</th>
                        </tr>
                    </thead>
                    <tbody cdkDropList [cdkDropListData]="filtered" [cdkDropListDisabled]="!canReorder"
                        (cdkDropListDropped)="onDrop($event)">
                        @for (item of filtered; track item.id) {
                            <!-- cdkDragEnded fires however the drag finishes, including a
                                 release outside the list, so the pinned widths always come off. -->
                            <!-- previewContainer="parent" is load-bearing: CDK appends the
                                 preview to <body> by default, where this component's
                                 encapsulated .cdk-drag-preview styles cannot reach it, so the
                                 preview rendered as an unstyled bare <tr>. Inserting it into the
                                 tbody keeps it inside the component's DOM.
                                 cdkDragEnded fires however the drag finishes, including a
                                 release outside the list, so the pinned widths always come off. -->
                            <tr cdkDrag [cdkDragData]="item" cdkDragLockAxis="y" [cdkDragDisabled]="!canReorder"
                                cdkDragPreviewContainer="parent" (cdkDragEnded)="unlockRowWidths()">
                                <td class="order-col">
                                    <!-- Handle rather than the whole row: the row also holds
                                         buttons and selectable text. Paired with the number it
                                         changes, so this column needs no separate header. -->
                                    <span class="grip" cdkDragHandle
                                        (pointerdown)="lockRowWidths($event)"
                                        [class.disabled]="!canReorder"
                                        [matTooltip]="canReorder ? 'Drag to reorder' : 'Clear the search to reorder'"
                                        matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faGripVertical"></fa-icon>
                                    </span>
                                    @if (item.displayOrder !== null) {
                                        <span class="order-value">{{ item.displayOrder }}</span>
                                    } @else {
                                        <span class="order-value muted"
                                            matTooltip="Sorts after every numbered project"
                                            matTooltipClass="admin-tooltip">—</span>
                                    }
                                </td>
                                <td class="thumb-col">
                                    @if (item.image && !imageBroken(item)) {
                                        <span class="thumb-slot">
                                            @if (imagePending(item)) {
                                                <!-- Holds the slot while a signed S3 URL is still in flight. -->
                                                <span class="thumb-skeleton" aria-hidden="true"></span>
                                            }
                                            <img [src]="item.image" [alt]="item.title" class="thumb"
                                                loading="lazy" decoding="async"
                                                [class.is-loaded]="!imagePending(item)"
                                                (load)="onImageLoad(item)" (error)="onImageError(item)" />
                                        </span>
                                    } @else {
                                        <span class="no-thumb" matTooltip="No image"
                                            matTooltipClass="admin-tooltip">—</span>
                                    }
                                </td>
                                <td class="title">{{ item.title }}</td>
                                <td>{{ item.location || '—' }}</td>
                                <td>{{ item.industry || '—' }}</td>
                                <td class="lang-col">
                                    <!-- An icon rather than a pill: the state is binary and the
                                         detail belongs in the tooltip, which names the languages
                                         and what a visitor actually sees. -->
                                    <span class="lang-state"
                                        [class.ok]="!missingLanguages(item).length"
                                        [class.warn]="missingLanguages(item).length"
                                        [matTooltip]="translationTooltip(item)"
                                        matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="missingLanguages(item).length
                                            ? faTriangleExclamation : faCircleCheck"></fa-icon>
                                    </span>
                                </td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="openEdit(item)"
                                        matTooltip="Edit" matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(item)"
                                        matTooltip="Delete" matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
